import React, { useState, useEffect } from "react";
import Logo from "../images/britam-logo-no-bg.png";
import Modal from "react-modal";

import CustomModal from "./popup";

import image from "../images/image.png";

const InterestForm = ({ setIsOpen, onClose }) => {
 
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true); // Set showModal to true on component mount
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    voucher: "",
    autoExpressStation: "",
    Product: "",
    voucherOption: "",
    showVoucherField: false,
  });

  const {
    fullName,
    phoneNumber,
    email,
    voucherOption,
    voucher,
    showVoucherField,
    autoExpressStation,
  } = formData;

  // useEffect(() => {
 

  const handleSubmit = (e) => {
    e.preventDefault();

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/xml");

    // let raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">\r\n<soap:Header xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">\r\n</soap:Header>\r\n<soapenv:Body>\r\n<ws:registerCustomer xmlns:ws="http://ws.britam/">\r\n<arg0>\r\n<NAME>${fullName}</NAME>\r\n<PHONENUMBER>${phoneNumber}</PHONENUMBER>\r\n<EMAIL>${email}</EMAIL>\r\n<VEHICLEMODEL>${vehicleModel}</VEHICLEMODEL>\r\n<YEAROFMANUFACTURE>${yearOfManufacture}</YEAROFMANUFACTURE>\r\n<CURRENTVALUATION>${currentValuation}</CURRENTVALUATION>\r\n<TYPEOFCOVER>${typeOfCover}</TYPEOFCOVER>\r\n</arg0>\r\n</ws:registerCustomer>\r\n</soapenv:Body>\r\n</soapenv:Envelope>`;
    let raw = `<soapenv:Envelope 
    xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">
    
    <soap:Header 
    xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    
    </soap:Header>
    
    <soapenv:Body>
    
    <ws:registerCustomer 
    xmlns:ws="http://ws.britam/">
    
    <!--Optional:-->
    
    <arg0>
    
    <NAME>${fullName}</NAME>
    
    <PHONENUMBER>${phoneNumber}</PHONENUMBER>
    
    <EMAIL>${email}</EMAIL>
    
    <ASSIGNEE>string</ASSIGNEE>
    
    <NATUREOFINTERACTION>string</NATUREOFINTERACTION>
    
    <INTERACTION>string</INTERACTION>
    
    <INTERESTED>string</INTERESTED>
    
    <ENGAGEMENTSTATUS>string</ENGAGEMENTSTATUS>
    
    <PAYMENTSTATUS>string</PAYMENTSTATUS>
    
    <NATUREOFCALL>string</NATUREOFCALL>
    
    <PRODUCT>string</PRODUCT>
    
    <VOUCHER>${voucher}</VOUCHER>
    
    <VEHICLETYPE>string</VEHICLETYPE>
    
    <AUTOEXPRESSSTATION>string</AUTOEXPRESSSTATION>
    
    <VOUCHEROPTION>${voucherOption}</VOUCHEROPTION>
    
    </arg0>
    
    </ws:registerCustomer>
    
    </soapenv:Body>
    
    </soapenv:Envelope>`;

    let requestOptions = {
      mode: "no-cors",
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    //fetch("http://10.10.4.62:9005/AutoExpress/ProxyService/AutoExpressPipelineProxyService", requestOptions)



    fetch(
      "https://miniapps.britam.com/AutoExpress/ProxyService/AutoExpressPipelineProxyService",
      

      requestOptions
    )
      .then((response) => {
        response.text();
        setIsOpen(true);
        setFormData({
          fullName: "",
          phoneNumber: "",
          email: "",
          voucher: "",
          autoExpressStation: "string",
          Product: "",
          voucherOption: "",
        });
      })
      .then((result) => {
        console.log('AutoExpressPipelineProxyService passed------------------')
        console.log(result);
        // payments();
      })
      .catch((error) => console.log("error", error));
  };



  const handleChange = (event) => {
    const { name, value } = event.target;
  
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };
  
      if (name === "voucherOption") {
        if (value === "Yes") {
          updatedFormData.voucherOption = "Yes"; // Clear voucherOption when changing typeOfCover
          updatedFormData.voucher = ""; // Clear voucher when changing typeOfCover
          updatedFormData.showVoucherField = true;
        } else {
          updatedFormData.showVoucherField = false;
          // Assign a hardcoded value when the user selects "No" for voucher
          updatedFormData.voucher = "NoVoucher"; // Set the hardcoded value here
        }
      }
  
      return updatedFormData;
    });
  };




  return (
    <article className="h-screen relative container  bg-cover bg-no-repeat m-auto  w-auto bg-gradient-to-r from-cyan-500 to-blue-700 flex items-center overflow-auto">
      <CustomModal isOpen={showModal} onClose={closeModal}>
        <div
          class="flex flex-col justify-start items-center lg:w-[1011px] md:w-[700px]  xs:w-[400px]  overflow-hidden rounded-xl  bg-white"
          style={{
            boxShadow:
              "0px 20px 24px -4px rgba(16,24,40,0.08), 0px 8px 8px -4px rgba(16,24,40,0.03)", // Add other styles if needed
          }}
        >
          <div class="flex flex-col justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative">
            <div class="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4 px-6 pt-6">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex-grow-0 flex-shrink-0 w-12 h-12 relative"
                preserveAspectRatio="xMidYMid meet"
              >
                <g filter="url(#filter0_d_992_3206)">
                  <rect
                    x="2"
                    y="1"
                    width="48"
                    height="48"
                    rx="10"
                    fill="white"
                  ></rect>
                  <rect
                    x="2.5"
                    y="1.5"
                    width="47"
                    height="47"
                    rx="9.5"
                    stroke="#EAECF0"
                  ></rect>
                  <path
                    d="M16 27.4999L25.6422 32.3211C25.7734 32.3866 25.839 32.4194 25.9078 32.4324C25.9687 32.4438 26.0313 32.4438 26.0922 32.4324C26.161 32.4194 26.2266 32.3866 26.3578 32.3211L36 27.4999M16 22.4999L25.6422 17.6788C25.7734 17.6132 25.839 17.5804 25.9078 17.5675C25.9687 17.5561 26.0313 17.5561 26.0922 17.5675C26.161 17.5804 26.2266 17.6132 26.3578 17.6788L36 22.4999L26.3578 27.3211C26.2266 27.3866 26.161 27.4194 26.0922 27.4324C26.0313 27.4438 25.9687 27.4438 25.9078 27.4324C25.839 27.4194 25.7734 27.3866 25.6422 27.3211L16 22.4999Z"
                    stroke="#344054"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <filter
                    id="filter0_d_992_3206"
                    x="0"
                    y="0"
                    width="52"
                    height="52"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="1"></feOffset>
                    <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                    ></feColorMatrix>
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_992_3206"
                    ></feBlend>
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_992_3206"
                      result="shape"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
              <div class="flex flex-col justify-start items-center flex-grow relative gap-1">
                <p class="self-stretch flex-grow-0 flex-shrink-0  text-lg font-semibold text-left text-[#344054]">
                  Enjoy Amazing Discounts Courtesy of Britam and AutoXpress
                </p>
              </div>
            </div>

            <div class="flex justify-center items-center flex-grow-0 flex-shrink-0 absolute left-[955px] top-3 overflow-hidden p-2.5 rounded-lg" onClick={closeModal}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                preserveAspectRatio="xMidYMid meet"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </div>

            <div class="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 w-full h-5"></div>
            <svg
              width="1011"
              height="1"
              viewBox="0 0 1011 1"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="self-stretch flex-grow-0 flex-shrink-0"
              preserveAspectRatio="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1011 1H0V0H1011V1Z"
                fill="#EAECF0"
              ></path>
            </svg>
          </div>

          <div class="grid justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-5 px-6 py-5 w-full">
          {/* <div class="flex flex-col md:flex-row-reverse sm:flex-row-reverse xs:flex-row-reverse justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-5 px-6 py-5 bg-black"> */}

            <div class="grid lg:grid-cols-2 justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-5 w-full " >
              <div
                class="flex flex-col justify-start items-start flex-grow rounded-xl w-full 
                 border-2 border-[#0086c9]"
                style={{
                  boxShadow: "0px 1px 2px 0 rgba(16,24,40,0.05)", // Add other styles if needed
                }}
              >
                <div class="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-6 p-5">
                  <div class="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-3">
                    <div class="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g clip-path="url(#clip0_992_3182)">
                          <path
                            d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="#0086C9"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_992_3182">
                            <rect
                              width="24"
                              height="24"
                              rx="12"
                              fill="white"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <div class="flex flex-col justify-start items-start flex-grow relative">
                        <p class="self-stretch flex-grow-0 flex-shrink-0 w-full text-base text-left text-[#475467]">
                          Get a 10% discount off the standard premium when you
                          purchase Britam Motor Insurance Today!
                        </p>
                      </div>
                    </div>
                    <div class="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g clip-path="url(#clip0_992_3174)">
                          <path
                            d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="#0086C9"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_992_3174">
                            <rect
                              width="24"
                              height="24"
                              rx="12"
                              fill="white"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <div class="flex flex-col justify-start items-start flex-grow relative">
                        <p class="self-stretch flex-grow-0 flex-shrink-0 w-full text-base text-left text-[#475467]">
                          Receive Ksh 5000 Cash Voucher redeemable at any Auto
                          Xpress Centre!
                        </p>
                      </div>
                    </div>
                    <div class="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g clip-path="url(#clip0_992_3187)">
                          <path
                            d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="#0086C9"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_992_3187">
                            <rect
                              width="24"
                              height="24"
                              rx="12"
                              fill="white"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <div class="flex flex-col justify-start items-start flex-grow relative">
                        <p class="self-stretch flex-grow-0 flex-shrink-0 w-full text-base text-left text-[#475467]">
                          Earn a 10% No Claim Discount, redeemable at any
                          AutoXpress service center after 10 months!
                        </p>
                      </div>
                    </div>
                    <div class="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-3">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g clip-path="url(#clip0_992_3169)">
                          <path
                            d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="#0086C9"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_992_3169">
                            <rect
                              width="24"
                              height="24"
                              rx="12"
                              fill="white"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <div class="flex flex-col justify-start items-start flex-grow relative">
                        <p class="self-stretch flex-grow-0 flex-shrink-0  text-base text-left text-[#475467]">
                          Access 24/7 Assistance Accident Rescue Service all
                          year round!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" justify-start items-start flex-grow w-full h-[268px]  rounded-xl src border border-[#eaecf0] hidden md:block">
                <img
                  src={image}
                  alt="Your Image Alt Text"
                  className="object-fill rounded-xl w-full h-full"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-left items-left self-stretch flex-grow-0 flex-shrink-0 relative pl-[68px]">
            <p class="flex-grow-0 flex-shrink-0 lg:text-md xs:text-sm text-left font-semibold  text-[#344054]">
              Hurry! Grab this Deal Now and Experience Outstanding Benefits!
            </p>
            <div class="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative pb-4">
              <svg
                width="923"
                height="1"
                viewBox="0 0 923 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="self-stretch flex-grow-0 flex-shrink-0"
                preserveAspectRatio="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M923 1H0V0H923V1Z"
                  fill="#EAECF0"
                ></path>
              </svg>
            </div>
            <div class="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-3 px-6 pb-4">
              <div class="flex justify-end items-center flex-grow gap-3">
                <button className="rounded-lg bg-gradient-to-r from-sky-700 to-red-500 p-2 text-white text-md hover:text-md text-bold w-52 hover:opacity-80" onClick={closeModal}>
                  View Form
                </button>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      {/* <form className="m-auto bg-white/90 p-5" onSubmit={handleSubmit}> */}

      <form
        className="lg:m-auto md:m-auto sm:m-2 bg-white/90 p-5"
        onSubmit={handleSubmit}
      >
        <img
          src={Logo}
          alt="banner-poster"
          style={{ width: "10rem", height: "3rem", margin: "auto" }}
        />

        <h2 className="text-sky-600 text-xl font-bold text-center mb-2">
          BRITAM MOTOR INSURANCE
        </h2>
        <hr className="border-sky-500" />
        <div className="flex flex-wrap -mx-3 my-4">
          <div className="w-full px-3">
            <label
              className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Name <span className="text-red-600">*</span>
            </label>
            <input
              name="fullName"
              className="appearance-none block w-full bg-gray-200 text-sky-700 border-0 border-b-2 border-sky-300 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-sky-500"
              id="grid-name"
              type="text"
              placeholder="Enter your full name"
              value={fullName}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="flex flex-wrap -mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 md:mb-0">
            <label
              className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
              htmlFor="grid-phone-number"
            >
              Phone Number <span className="text-red-600">*</span>
            </label>
            <input
              name="phoneNumber"
              className="appearance-none block w-full bg-gray-200 text-sky-700 border-0 border-b-2 border-sky-300 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-sky-500"
              id="grid-phone-number"
              type="tel"
              placeholder="07XX XXX XXX"
              value={phoneNumber}
              onChange={handleChange}
              maxLength="10"
              minLength="10"
              required
            />
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
              htmlFor="grid-email"
            >
              Email <span className="text-red-600">*</span>
            </label>
            <input
              name="email"
              className="appearance-none block w-full bg-gray-200 text-sky-700 border-0 border-b-2 border-sky-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-sky-500"
              id="grid-email"
              type="email"
              placeholder="johndoe@gmail.com"
              value={email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="flex flex-wrap -mx-3 mb-4">
          {/* <div className="w-full md:w-1/2 px-3 md:mb-0 flex flex-col">
            <label
              className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
              htmlFor="grid-year"
            >
              where did you hear about the offer
            </label>
            <div className="relative">
              <select
                name="autoExpressStation"
                className="block appearance-none w-full bg-gray-200 border-0 border-b-2 border-sky-300 text-sky-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-sky-500"
                id="grid-year"
                value={autoExpressStation}
                onChange={handleChange}
              >
                <option value="">Choose an option</option>
                <option value="BURUBURU BRANCH">BURUBURU BRANCH </option>
                <option value="CITY CENTRE BRANCH">CITY CENTRE BRANCH </option>
                <option value="DONHOLM BRANCH">DONHOLM BRANCH</option>
                <option value="ELDORET RUPA MALL BRANCH">
                  ELDORET RUPA MALL BRANCH{" "}
                </option>
                <option value="EMBAKASI BRANCH">EMBAKASI BRANCH</option>
                <option value="EMBU BRANCH">EMBU BRANCH </option>
                <option value="ENTERPRISE ROAD BRANCH">
                  ENTERPRISE ROAD BRANCH
                </option>
                <option value="GARDEN CITY MALL BRANCH">
                  GARDEN CITY MALL BRANCH
                </option>
                <option value="GENERAL MATHENGE BRANCH">
                  GENERAL MATHENGE BRANCH{" "}
                </option>
                <option value="KILIMANI BRANCH">KILIMANI BRANCH </option>
                <option value="KISII BRANCH">KISII BRANCH </option>
                <option value="KISUMU BRANCH">KISUMU BRANCH </option>
                <option value="LAVINGTON BRANCH">LAVINGTON BRANCH </option>
                <option value="LUSAKA ROAD BRANCH">LUSAKA ROAD BRANCH</option>
                <option value="MOMBASA ROAD 2 BRANCH">
                  MOMBASA ROAD 2 BRANCH{" "}
                </option>
                <option value="NAIVASHA BRANCH">NAIVASHA BRANCH</option>
                <option value="NAKURU BRANCH">NAKURU BRANCH</option>
                <option value="NANYUKI BRANCH">NANYUKI BRANCH</option>
                <option value="NYERI BRANCH">NYERI BRANCH</option>
                <option value="PARKLANDS BRANCH">PARKLANDS BRANCH</option>
                <option value="SYOKIMAU BRANCH">SYOKIMAU BRANCH </option>
                <option value="THIKA BRANCH">THIKA BRANCH</option>
                <option value="UPPER HILL BRANCH">UPPER HILL BRANCH</option>
                <option value="WAIYAKI WAY BRANCH">WAIYAKI WAY BRANCH</option>
                <option value="Other">Other</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-sky-500">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div> */}

          <div className="w-full md:w-1/2 px-3">
            <label
              className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
              htmlFor="grid-state"
            >
              Do you have an SMS serial code?
            </label>
            <div className="relative">
              <select
                name="voucherOption"
                className="block appearance-none w-full bg-gray-200 border-0 border-b-2 border-sky-300 text-sky-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="grid-state"
                value={voucherOption}
                onChange={handleChange}
                required
              >
                <option value="">Choose an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-sky-500">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>


          {showVoucherField && (
            <div className="w-full md:w-1/2 px-3 md:mb-0">
              <label
                className="block uppercase tracking-wide text-sky-500 text-xs font-bold mb-2"
                htmlFor="grid-phone-number"
              >
                Enter The SMS serial code <span className="text-red-600">*</span>
              </label>
              <input
                name="voucher"
                className="appearance-none block w-full bg-gray-200 text-sky-700 border-0 border-b-2 border-sky-300 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-sky-500"
                id="grid-phone-number"
                type="text"
                placeholder="BRITAM XXXX"
                value={voucher}
                onChange={handleChange}
                maxLength="10"
                minLength="3"
                required
              />
            </div>
        )}
        </div>

        {/* Conditional rendering of the voucher code field */}

        <div className="form-check text-center mb-4 flex flex-col">
          <div>
            <input
              className="form-check-input"
              type="checkbox"
              id="check1"
              name="option1"
              required
            />
            <label className="form-check-label text-sky-500 px-2">
              I have read and agree to the
              <a
                href="https://ke.britam.com/help/other-services/terms-and-conditions"
                className="text-red-600"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Terms and Conditions
              </a>
            </label>
          </div>
        </div>
        <footer className="grid justify-center">
          <button className="rounded-lg bg-gradient-to-r from-sky-700 to-red-500 p-2 text-white text-lg hover:text-xl text-bold w-52 hover:opacity-80">
            Submit
          </button>
        </footer>
      </form>
    </article>
  );
};

export default InterestForm;
